// @flow
import Proposition from 'common/modules/proposition/domain/proposition';
import type { Dispatch, GetState } from '../../../types/Store';
import { getStation, getToken } from '../../authentication/session/reducers/sessionReducer';
import SalesPropositionApi from '../services/SalesPropositionApi';

export const PROPOSE_SALES_ESTIMATION = 'salesProposition/PROPOSE_SALES_ESTIMATION';
export const PROPOSE_SALES_ESTIMATION_SUCCESS = 'salesProposition/PROPOSE_SALES_ESTIMATION_SUCCESS';
export const PROPOSE_SALES_ESTIMATION_ERROR = 'salesProposition/PROPOSE_SALES_ESTIMATION_ERROR';

export const SEND_SALES_PROPOSITION = 'salesProposition/SEND_SALES_PROPOSITION';
export const SEND_SALES_PROPOSITION_SUCCESS = 'salesProposition/SEND_SALES_PROPOSTIION_SUCCESS';
export const SEND_SALES_PROPOSITION_ERROR = 'salesProposition/SEND_SALES_PROPOSTIION_ERROR';

export function proposeSalesEstimation(proposition: Proposition) {
  return async (dispatch: Dispatch, getState: GetState) => {
    try {
      dispatch({ type: PROPOSE_SALES_ESTIMATION, estimation: proposition.estimation });

      const callSign = getStation(getState());
      const token = getToken(getState());

      const result = await SalesPropositionApi.createSalesProposition(callSign, token, proposition);

      dispatch({ type: PROPOSE_SALES_ESTIMATION_SUCCESS, proposition: result });
    } catch (error) {
      dispatch({ type: PROPOSE_SALES_ESTIMATION_ERROR, estimation: proposition.estimation });
    }
  };
}

export function sendSalesProposition(proposition: Proposition) {
  return async (dispatch: Dispatch, getState: GetState) => {
    try {
      dispatch({ type: SEND_SALES_PROPOSITION, proposition });

      const callSign = getStation(getState());
      const token = getToken(getState());

      const modifiedProposition = await SalesPropositionApi.send(callSign, token, proposition.reference);

      dispatch({ type: SEND_SALES_PROPOSITION_SUCCESS, proposition: modifiedProposition });
    } catch (error) {
      dispatch({ type: SEND_SALES_PROPOSITION_ERROR, error });
      throw error;
    }
  };
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/sales/actions/salesPropositionActions.js